import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { removeUrlProtocol } from '@mssgme/shared';
import { useIsMobile } from '../../hooks';
import { CopyContainer } from '../CopyContainer';
import { LinkBlank } from '../LinkBlank';

CopyLink.propTypes = {
    onCopy: PropTypes.func,
    href: PropTypes.string,
    noUrlLabel: PropTypes.string,
    share: PropTypes.bool,
    clickable: PropTypes.bool,
    legacy: PropTypes.bool,
    className: PropTypes.any,
    tagClassName: PropTypes.any,
    buttonClassName: PropTypes.any,
    copiedClassName: PropTypes.any,
};

export function CopyLink({ href = '', noUrlLabel, clickable, share = false, onCopy, ...rest }) {
    const { t } = useTranslation('ui');
    const isMobile = useIsMobile();
    const isNativeShare = share && 'share' in navigator && isMobile;

    const handleCopy = useCallback(
        (e) => {
            if (isNativeShare) {
                void navigator.share({ url: href });

                return false;
            } else {
                onCopy && onCopy(e);
            }
        },
        [isNativeShare, href, onCopy]
    );

    if (clickable && href) {
        rest.as = LinkBlank;
        rest.href = href;
    }

    return (
        <CopyContainer text={href} copyTitle={isNativeShare && t('labels.share')} onCopy={handleCopy} {...rest}>
            {href ? removeUrlProtocol(href) : noUrlLabel}
        </CopyContainer>
    );
}
